import './Header.css'
import { CURRENT_PTWAVE_VERSION } from '../../version';

const logoPath = '/images/logo_small.webp';

function Header() {
    return (
        <header className="app-header">
            <div className="header-content">
                <img src={logoPath} alt="PtWAVE Logo" className="header-logo" />
                <h1 className="header-title">PtWAVE</h1>
                <span className="header-version">version {CURRENT_PTWAVE_VERSION}</span>
            </div>
        </header>
    );
}

export default Header;
